import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta:{
      isShow:false,
    },
  },{
    path: '/BaseImage',
    name: 'BaseImage',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "BaseImage" */ '../views/base/BaseImage.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta:{
      isShow:true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path:'/entrance',
    name:'Entrance',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "Entrance" */ '../views/Entrance.vue')
  },
  {
    path:'/login',
    name:'Login',
    meta:{
      isShow:true,
    },
    component: Login
  },
  {
    path: '/notice',
    name: 'Notice',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "notice" */ '../views/Notice.vue')
  }
  ,
  {
    path: '/review',
    name: 'Review',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "review" */ '../views/review/Review.vue')
  },
  {
    path: '/ReformSubmitJudges',
    name: 'ReformSubmitJudges',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "review" */ '../views/review/ReformSubmitJudges.vue')
  },
  {
    path: '/reviewDetail',
    name: 'ReviewDetail',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "reviewDetail" */ '../views/review/ReviewDetail.vue')
  },
  {
    path: '/reviewScore',
    name: 'ReviewScore',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "reviewScore" */ '../views/review/ReviewScore.vue')
  },
  {
    path: '/noticeDetail',
    name: 'NoticeDetail',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "noticeDetail" */ '../views/NoticeDetail.vue')
  },
  {
    path: '/submit',
    name: 'Submit',
    component: () => import(/* webpackChunkName: "submit" */ '../views/Submit.vue'),
    meta:{
      isShow:true,
    },
    children:[
      {
        path: '/psychologyTemp',
        name: 'PsychologyTemp',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "psychologyTemp" */ '../views/template/PsychologyTemp.vue')
      },
      {
        path: '/productTemp',
        name: 'ProductTemp',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "productTemp" */ '../views/template/ProductTemp.vue')
      },
      {
        path: '/productTemp1',
        name: 'ProductTemp1',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "productTemp" */ '../views/template/ProductTemp1.vue')
      },
      {
        path: '/realityTemp',
        name: 'RealityTemp',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "realityTemp" */ '../views/template/RealityTemp.vue')
      },{
        path: '/teachTemp',
        name: 'TeachTemp',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "teachTemp" */ '../views/template/TeachTemp.vue')
      },{
        path: '/ProjectSubmit',
        name: 'ProjectSubmit',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "teachTemp" */ '../views/template/ProjectSubmit.vue')
      },{
        path: '/ConcludeSubmit',
        name: 'ConcludeSubmit',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "teachTemp" */ '../views/template/ConcludeSubmit.vue')
      },{
        path: '/postgraduateTemp',
        name: 'PostgraduateTemp',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "postgraduateTemp" */ '../views/template/postgraduate/PostgraduateFirstDraftTemp.vue')
      },{
        path: '/postgraduateProfessionalPracticeMaterials',
        name: 'PostgraduateProfessionalPracticeMaterials',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "postgraduateProfessionalPracticeMaterials" */ '../views/template/postgraduate/PostgraduateProfessionalPracticeMaterials.vue')
      },{
        path: '/temp',
        name: 'Temp',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "temp" */ '../views/template/Temp.vue')
      },{
        path: '/userConsult',
        name: 'userConsult',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "temp" */ '../views/ApplyMind/User/userConsult.vue')
      },{
        path: '/userCase',
        name: 'userCase',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "temp" */ '../views/ApplyMind/User/userCase.vue')
      },{
        path: '/userSkill',
        name: 'userSkill',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "temp" */ '../views/ApplyMind/User/userSkill.vue')
      },{
        path: '/userPopularization',
        name: 'userPopularization',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "temp" */ '../views/ApplyMind/User/userPopularization.vue')
      }
    ]
  },
  {
    path: '/backIndex',
    name: 'BackIndex',
    meta:{
      isShow:false,
    },
    redirect:'/backIndex/school',
    component: () => import(/* webpackChunkName: "backIndex" */ '../views/Backstage/BackIndex.vue'),
    children:[{
      path: '/backIndex/stage',
      name: 'Stage',
      meta:{
        isShow:true,
      },
      component: () => import(/* webpackChunkName: "stage" */ '../views/Backstage/Stage.vue')
    },
      {
        path: '/backIndex/school',
        name: 'School',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "school" */ '../views/Backstage/School.vue')
      },
      {
        path: '/backIndex/user',
        name: 'User',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "user" */ '../views/Backstage/user/User.vue')
      },
      {
        path: '/backIndex/userJudgesEdit',
        name: 'UserJudgesEdit',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "userJudgesEdit" */ '../views/Backstage/user/UserJudgesEdit.vue')
      }
      ,
      {
        path: '/backIndex/userStudentEdit',
        name: 'UserStudentEdit',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "userStudentEdit" */ '../views/Backstage/user/UserStudentEdit.vue')
      },
      {
        path: '/backIndex/userTutorEdit',
        name: 'UserTutorEdit',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "userTutorEdit" */ '../views/Backstage/user/UserTutorEdit.vue')
      },
      {
        path: '/backIndex/product',
        name: 'Product',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "product" */ '../views/Backstage/product/Product.vue')
      },
      {
        path: '/backIndex/SubmitReform',
        name: 'SubmitReform',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "SubmitReform" */ '../views/Backstage/product/SubmitReform.vue')
      },
      {
        path: '/backIndex/ConcludeSubmit',
        name: 'ConcludeSubmit1',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "ConcludeSubmit" */ '../views/Backstage/product/ConcludeSubmit.vue')
      },
      
      {
        path: '/ApplyMind/mindPractice',
        name: 'mindPractice',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "SubmitReform" */ '../views/ApplyMind/mindPractice.vue')
      },
      {
        path: '/backIndex/backNotice',
        name: 'BackNotice',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "backNotice" */ '../views/Backstage/notice/BackNotice.vue')
      },
      {
        path: '/backIndex/publishNotice',
        name: 'PublishNotice',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "publishNotice" */ '../views/Backstage/notice/NoticeDetail.vue')
      },
      {
        path: '/backIndex/score',
        name: 'Score',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "score" */ '../views/Backstage/score/Score.vue')
      },
      {
        path: '/backIndex/scoreEdit',
        name: 'ScoreEdit',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "scoreEdit" */ '../views/Backstage/score/ScoreEdit.vue')
      },
      {
        path: '/backIndex/scoreDetail',
        name: 'ScoreDetail',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "ScoreDetail" */ '../views/Backstage/score/ScoreDetail.vue')
      },
      {
        path: '/backIndex/resetPassword',
        name: 'ResetPassword',
        meta:{
          isShow:true,
        },
        component: () => import(/* webpackChunkName: "resetPassword" */ '../views/Backstage/ResetPassword.vue')
      }
    ]
  }
  ,{
    path: '/info',
    name: 'Info',
    meta:{
      isShow:true,
    },
    component: () => import(/* webpackChunkName: "info" */ '../views/info/Info.vue'),
    children:[
      {
        path:'/info/password',
        name:'Password',
        meta:{
          isShow:true
        },
        component: () => import(/* webpackChunkName: "password" */ '../views/info/InfoPassword.vue')
      },
      {
        path:'/info/batch',
        name:'Batch',
        meta:{
          isShow:true
        },
        component: () => import(/* webpackChunkName: "batch" */ '../views/info/InfoBatch.vue')
      },
      {
        path:'/info/studentEdit',
        name:'InfoStudentEdit',
        meta:{
          isShow:true
        },
        component: () => import(/* webpackChunkName: "infoStudentEdit" */ '../views/info/InfoStudentEdit.vue')
      },
      {
        path:'/info/tutorEdit',
        name:'InfoTutorEdit',
        meta:{
          isShow:true
        },
        component: () => import(/* webpackChunkName: "infotutorEdit" */ '../views/info/InfoTutorEdit.vue')
      },
      {
        path:'/info/judgesEdit',
        name:'InfoJudgesEdit',
        meta:{
          isShow:true
        },
        component: () => import(/* webpackChunkName: "judgesEdit" */ '../views/info/InfoJudgesEdit.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
